<template>
  <v-btn tile :dark="dark" :color="color" @click="doHandlerClick()" :disabled="disabled">
    <v-icon left>{{iconCls}}</v-icon>{{label}}
  </v-btn>
</template>

<script>
export default {
  name: "RyouBlueBtn",
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    color: {
      type: String,
      required: false,
      default: "#0D47A1 "
    },
    iconCls: {
      type: String,
      required: false,
      default: "mdi-plus"
    },
    handlerClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    dark: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    doHandlerClick() {
      this.handlerClick();
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>
